import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import SettingForm from './SettingForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditSettingModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }

    submitHandler = ( { item } ) => {
        this.setState( { fetching: true } );

        this.props.updateItem( item.id, item )
        .then( ( newItem ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newItem );
        } );
    }

    render() {
        const { item } = this.props;
        var initialValues = {
            ...item,
        };

        return (
            <DLModal title='Edit Setting'
            closeHandler={ this.props.closeModal }>
                <div>
                    <SettingForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateItem: ( id, data ) => {
            return dAPI.patch( `/admin/settings/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditSettingModal );
